import React from 'react';

const TextAreaSimple = ({ row, label, value, onChange, error }) => (
	<div className="Input-Simples">
		{ label && (<label>{label}</label>) }
		<textarea
			rows={row}
			value={value != null ? value : ""}
			onChange={onChange}
			className={`${error ? "input-error" : ""}`}
		/>
		{ error && (<small className="small-danger">{error}</small>) }
	</div>
)

export default TextAreaSimple;